import { Injectable, inject } from '@angular/core';
import { SyncStore } from './sync-store.service';

export const WELLNESS_TIP_KEYS = [
  'receptors',
  'bloating',
  'spotting',
  'wordSearch',
  'sensoryThreshold',
  'morningStiffness',
  'prickling',
  'caffeine',
  'tracking',
] as const;

export type WellnessTipKey = (typeof WELLNESS_TIP_KEYS)[number];

const STORAGE_KEY = 'peritale.wellnessTipsSeen.v1';

@Injectable({ providedIn: 'root' })
export class WellnessTipsService {
  private sync = inject(SyncStore);

  pickUnseen(exclude: WellnessTipKey[] = []): WellnessTipKey {
    const seen = this.readSeen();
    const excludeSet = new Set([...exclude]);
    let pool = WELLNESS_TIP_KEYS.filter(
      (k) => !seen.includes(k) && !excludeSet.has(k),
    );
    if (pool.length === 0) {
      this.writeSeen([]);
      pool = WELLNESS_TIP_KEYS.filter((k) => !excludeSet.has(k));
    }
    if (pool.length === 0) pool = [...WELLNESS_TIP_KEYS];
    return pool[Math.floor(Math.random() * pool.length)];
  }

  markSeen(key: WellnessTipKey): void {
    const seen = this.readSeen();
    if (seen.includes(key)) return;
    seen.push(key);
    this.writeSeen(seen);
  }

  private readSeen(): WellnessTipKey[] {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.filter((k): k is WellnessTipKey =>
        (WELLNESS_TIP_KEYS as readonly string[]).includes(k),
      );
    } catch {
      return [];
    }
  }

  private writeSeen(keys: WellnessTipKey[]): void {
    this.sync.setJSON(STORAGE_KEY, keys);
  }
}
